module.exports = __webpack_public_path__ + "img/Thumbnail_ZWF_Lucas_Thayna.9af5876f.jpg";